import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from './../../../config/page-settings.js';

import RolesList from './RolesList';

const RolesManagement = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  const createRole = () => {
    props.history.push('/settings/roles/create');
  };

  return (
    <div>
      <h1 className="page-header">
        Roles Management{' '}
        <button onClick={createRole} className="btn btn-primary btn-icon btn-circle btn-md ml-2">
          <i className="fa fa-plus"></i>
        </button>
      </h1>
      <RolesList />
    </div>
  );
};

export default withRouter(RolesManagement);
